import { useLocation } from '@reach/router';
import { Link } from 'gatsby';
import { storyblokEditable } from 'gatsby-source-storyblok';
import React, { useEffect } from 'react';
import { getStoryblokAlt } from '../../helpers/common';

const getStoryblokDimensions = (url) => {
  const [rawWidth, rawHeight] = url?.split('/')[5]?.split('x') || [];
  const width = Number.parseInt(rawWidth, 10);
  const height = Number.parseInt(rawHeight, 10);

  return {
    width: Number.isNaN(width) ? undefined : width,
    height: Number.isNaN(height) ? undefined : height,
  };
};

function SuccessPage({ blok }) {
  const location = useLocation();
  const urlParam = new URLSearchParams(location.search).get('conversion');
  useEffect(() => {
    window.gtag = window.gtag || function gtag(...args) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(args);
    };

    // Extract the URL parameter from the location object

    // Send the conversion event to Google Analytics if cookie is not set
    if (typeof window.gtag !== 'undefined' && urlParam && !document.cookie.includes('conversion')) {
      window.gtag('event', urlParam === 'launchplan' ? 'submit_launchplan_form' : 'submit_contact_form', {
        event_category: 'Form Submission',
        event_label: urlParam,
      });

      // save cookie for 1 day to not fire conversion again
      const date = new Date();
      date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
      document.cookie = `conversion=${urlParam}; expires=${date.toUTCString()}; path=/`;
    }
  }, [location, urlParam]);
  const {
    title, subtitle, button_text: buttonText, button_link: buttonLink,
    lanchplan_button_link: lauchplanButtonLink, lauchplan_button_text: lauchplanButtonText,
    launchplan_subtitle: launchplanSubtitle, launchplan_title: launchplanTitle, icon,
  } = blok;
  const { width: iconWidth, height: iconHeight } = getStoryblokDimensions(icon?.filename);

  return (
    <div className="bg-gray-100 h-auto py-24" {...storyblokEditable(blok)}>
      <div className="bg-white p-6 mx-auto w-fit">
        <img
          src={icon.filename}
          alt={getStoryblokAlt(icon, 'success icon')}
          width={iconWidth}
          height={iconHeight}
          className=" text-latori-green w-16 h-16 mx-auto my-6"
          loading="lazy"
          decoding="async"
        />
        <div className="text-center">
          <h3 className="md:text-2xl text-base text-gray-900 font-semibold text-center">{urlParam === 'launchplan' ? launchplanTitle : title}</h3>
          <p className="text-gray-600 my-2">
            {urlParam === 'launchplan' ? launchplanSubtitle : subtitle}
            {' '}
          </p>
          <div className="py-10 text-center">
            { urlParam === 'launchplan' ? (
              <Link to={`${lauchplanButtonLink.cached_url.startsWith('/') ? lauchplanButtonLink.cached_url : `/${lauchplanButtonLink.cached_url}`}`} title={lauchplanButtonLink?.link_title || undefined} className="button-primary success-btn">
                {lauchplanButtonText}
              </Link>
            ) : (
              <Link to={buttonLink.cached_url.startsWith('/') ? buttonLink.cached_url.replace('home', '') : buttonLink.cached_url.replace('home', '/')} title={buttonLink?.link_title || undefined} className="button-primary ">
                {buttonText}
              </Link>
            )}

          </div>
        </div>
      </div>
    </div>
  );
}

export default SuccessPage;
